/**
 * TanStack Query mutation for deleting a KYC form via tRPC.
 */

import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";

export function useKYBDelete() {
	const queryClient = useQueryClient();
	const utils = trpc.useUtils();

	const mutation = trpc.kyb.delete.useMutation({
		onSuccess: (_data, variables) => {
			queryClient.removeQueries({ queryKey: ["kyb", variables.id] });
			utils.kyb.list.invalidate();
		},
	});

	return {
		...mutation,
		mutate: (formId: string) => {
			mutation.mutate({ id: formId });
		},
		mutateAsync: async (formId: string) => {
			await mutation.mutateAsync({ id: formId });
		},
	};
}
